<template>
    <div class="app has-header">
        <div class="header main">

            <div class="align-left">
                <select v-if="times.length > 0 && showComponent === 'lanes'" id="dropdown" v-model="selectedTime" class="label-bold"
                    style="background: var(--contrast-1); height: 55px; padding-left: 5px;">
                    <option v-for="(timeSlot, index) in times" :key="index" :value="timeSlot.id" class="label-bold">
                        {{ timeSlot.name }}
                    </option>
                </select>
                <dateselectionheader v-if="showComponent === 'table'" style="position: relative; top: auto; left: auto;
                    width: auto; margin: 0;" :label="dateSelectionStart.format('DD-MM-YY')"
                    @PrevDate="setDateSelection(dateSelectionStart.add(-1, 'day'), true)"
                    @NextDate="setDateSelection(dateSelectionStart.add(1, 'day'), true)"
                    @CalendarOpen="OpenDateSelection"
                    @SetToday="setDateSelection($helpers.getCurrentMonthMomentTZ(), true)"/>
                <select v-if="showComponent === 'table'" id="dropdown-vlh-table" v-model="selectedTableMode" class="label-bold"
                        style="background: var(--contrast-1); height: 55px; padding-left: 5px;">
                    <option v-for="(mode, index) in tableModes" :key="index" :value="mode.value"
                            class="label-bold">
                        {{ mode.label }}
                    </option>
                </select>
            </div>
            <div class="align-middle">
                <headerbuttonstack :state="headerButtons" />
            </div>
            <div class="align-right">
                <headerbuttonstack :state="sideButtons" />
            </div>
        </div>
        <div v-if="showComponent === 'lanes'" class="scrollbar-container" style="background: var(--contrast-0)" :class="anonMode ? 'anonblur' : ''">
            <div v-if="!times.length > 0" style="color: var(--col-label-default)">
                <h3 style="margin-top: 50px">{{ $t('indicator.vlh.addTimePeriods') }}
                    -></h3>
                <div style="max-width: fit-content;  margin-left: auto;  margin-right: auto;">
                    <div class="section">
                        <h3>{{ $t('indicator.vlh.orInitiallyHere') }}:</h3>
                        <div class="time-table-header vlh-pl-5" style="width: 500px">{{ $t('roster.comp.timeFrame') }}
                            <div style="float: right">
                                <i class="fas fa-plus-circle add-btn" @click="OpenCreateVlhTimeFrameModal()"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="mainType">
                <div class="vlh-lane">
                    <div v-for="lane in lanes" :key="lane.name">
                        <div class="vlh-lane-section vlh-light-gray">
                            <div class="vlh-section-label" :style="{ 'background-color': lane.color }">
                                {{ lane.name }}
                                <button class="vlh-light-btn" :style="{ 'background-color': lane.color }"
                                    @click="OpenCreateVlhEmployeeThresholdModal($event, lane.time, getSpotsForUnit(lane.unitId))">
                                    <i class="fas fa-plus-circle"></i>
                                </button>
                            </div>
                            <div v-for="state in lane" :key="state.cardId">
                                <div>
                                    <card :state="state" :laneColor="lane.color"
                                        :OpenCreateVlhEmployeeThresholdModal="OpenCreateVlhEmployeeThresholdModal"
                                        :OpenEditVlhEmployeeThresholdModal="OpenEditVlhEmployeeThresholdModal"
                                        :OpenDeleteVlhEmployeeThresholdModal="OpenDeleteVlhEmployeeThresholdModal" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <h3 v-else style="color: red;">{{ $t('roster.error.defaultKeyFigureMissing') }}</h3>
        </div>
        <vlhsidebar v-if="showComponent === 'lanes'" :tabs="sideMenuState" :orderedVlhTimeFrames="orderedVlhTimeFrames"
                    :visibleTimeFrames="visibleTimeFrames" :OpenCreateVlhTimeFrameModal="OpenCreateVlhTimeFrameModal"
                    :OpenEditVlhTimeFrameModal="OpenEditVlhTimeFrameModal"
                    :OpenDeleteVlhTimeFrameModal="OpenDeleteVlhTimeFrameModal" :vlhConfigForMainType="vlhConfigForMainType"
                    :OpenCreateVlhConfigModal="OpenCreateVlhConfigModal" :OpenEditVlhConfigModal="OpenEditVlhConfigModal"
                    :OpenDeleteVlhConfigModal="OpenDeleteVlhConfigModal" :orderedVlhConversions="orderedVlhConversions"
                    :OpenCreateVlhConversionModal="OpenCreateVlhConversionModal"
                    :OpenEditVlhConversionModal="OpenEditVlhConversionModal"
                    :OpenDeleteVlhConversionModal="OpenDeleteVlhConversionModal">
        </vlhsidebar>

        <div v-if="showComponent === 'table'" class="scrollbar-container vlh-curve" :class="anonMode ? 'anonblur' : ''">
            <datatablesimple :state="vlhTableState" :collapsedStateProp="dataTableCollapsedState"
                             @collapsedStatesChanged="dataTableCollapsedState = $event" />
        </div>

        <div v-if="loading" class="loading-md bg">
            <i class="fas fa-spinner"></i>
            <div v-if="!$helpers.isEmpty(loadingText)" class="loading-text">
                {{ loadingText }}
            </div>
        </div>
    </div>
</template>

<script>
import Card from '@/components/uicomponents/card.vue';

import { mapGetters } from 'vuex';
import Vlhsidebar from '@/components/uicomponents/vlhsidebar.vue';
import Dropdownsearch from '@/components/uicomponents/dropdownsearch.vue';

export default {
    name: 'vlhconfigoverview',
    components: {
        Dropdownsearch,
        Vlhsidebar,
        Card,
    },
    data() {
        return {
            dateSelectionStart: this.$helpers.getCurrentMonthMomentTZ(),
            error: false,
            loading: true,
            loadingText: null,
            showConfig: true,
            visibleTimeFrames: new Set(),
            filterDropdownOptions: [],
            selectedTime: null,
            showComponent: 'lanes',
            tableModes: [ { label: this.$t('indicator.vlh.quarterHour'), value: 0 }, { label: this.$tc('global.ui.hours'), value: 1 }, {
                label: this.$tc('global.general.day'),
                value: 2,
            } ],
            selectedTableMode: 0,
            thresholdCurve: null,
            dataTableCollapsedState: {},
        }
    },

    created: function () {
        if (this.$store.state.jwt !== undefined && this.$store.state.storeId !== undefined) {
            this.refresh();
        }
    },
    computed: {
        ...mapGetters(['storeId', 'rosterFromTo', 'anonMode', 'vlhTimeFrameMap', 'vlhConversionMap', 'vlhConfigMap', 'planningIndicatorTypeMap', 'vlhEmployeeThresholdMap', 'spotMap', 'businessUnitMap', 'storeSettings', 'isSuperUser']),
        headerButtons() {

            let view = this;

            let state = {
                buttons: []
            };
            //BUTTON 1
            if (this.mainType != null && this.times.length > 0) {
                state.buttons.push({
                    type: "block",
                    icon: "fa-sync-alt",
                    click: () => {
                        view.refresh(true);
                    },
                    tooltip: this.$t('global.general.refreshData')
                });

                state.buttons.push({
                    type: "block green",
                    icon: "fa-plus",
                    click: ($event) => {
                        view.OpenCreateMultipleVlhEmployeeThresholdModal($event);
                    },
                    tooltip: this.$t('indicator.vlh.addMultipleValues'),
                    helperText: this.$t('indicator.meo.addMultipleHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2686779412"
                });
                if(this.selectedTime != null){
                    state.buttons.push({
                        type: "block orange",
                        icon: "fa-plus",
                        click: ($event) => {
                            view.OpenReverseVlhEmployeeThresholdModal($event);
                        },
                        tooltip: this.$t('indicator.vlh.createFromRoster'),
                        helperText: this.$t('indicator.vlh.createFromRosterHelp'),
                        externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2686779412"
                    });
                }
                console.log(this.selectedTime);


                state.buttons.push({
                    type: "block red",
                    icon: "fa-times",
                    click: ($event) => {
                        view.openDeleteConfirmAlert();
                    },
                    tooltip: this.$t('indicator.vlh.deleteValues'),
                    helperText: this.$t('indicator.vlh.deleteValuesHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/kb/view/2686779412"
                });
                /*
                if (this.isSuperUser) {
                    state.buttons.push({
                        type: "block border-r",
                        icon: "fa-poll",
                        click: ($event) => {
                            view.OpenVlhEmployeeThresholdCurveModal($event);
                        },
                        tooltip: 'Kurve laden',
                        helperText: "",

                    });
                } */
                if (this.showComponent === 'lanes') {
                    state.buttons.push({
                        type: "block border-r",
                        icon: "fa-table",
                        click: ($event) => {
                            view.OpenVlhEmployeeThresholdCurveView($event);
                        },
                        tooltip: this.$t('indicator.vlh.showStaffingTable'),
                        helperText: "",

                    });
                }
                if (this.showComponent === 'table') {
                    state.buttons.push({
                        type: "block border-r",
                        icon: "fa-line-columns",
                        click: () => {
                            view.closeVlhEmployeeThresholdCurveView();
                        },
                        tooltip: this.$t('indicator.vlh.showTable'),
                        helperText: "",

                    });
                }
            }


            state.helperLinks = [

                {
                    title:  this.$t('store.structure.getSupport'),
                    helperText:  this.$t('store.structure.getSupportHelp'),
                    externalUrl: "https://meindienstplan.atlassian.net/servicedesk/customer/portal/1/group/2/create/13",
                    externalLabel:  this.$t('store.structure.getSupportLabel'),
                    cancelLabel: this.$t('global.ui.close')
                }
            ];
            return state;
        },
        sideButtons() {
            let view = this;

            let state = {
                buttons: [
                    {
                        classes: "spot-filter",
                        type: "block",
                        disabled: false,
                        icon: "fa-filter",
                        click: ($event) => {
                            view.OpenFilterDropdown($event);
                        },
                        show: true,
                        tooltip: this.$t('global.ui.viewFilter'),
                    },
                ]
            };


            return state;
        },
        sideMenuState() {
            let view = this;

            let tabs = [];

            tabs.push({
                tabHeader: this.$t('roster.comp.timeFrame'),
                components: [{
                    type: 'datafill',
                }],
            })

            return [{
                label: this.$t('roster.comp.timeFrame'),
                view: 'dropdowncontainer',
                bgcolor: view.allowMdConfirm ? '#6d8d23' : '',
                color: view.allowMdConfirm ? '#e8f5e7' : '',
                props: {
                    styles: { position: 'absolute', width: 'calc(100% - 40px)', top: '140px', left: '20px' },
                    state: {
                        staticElement: true,
                        tabs: tabs
                    }
                }
            }];
        },
        mainType() {
            let def = Object.values(this.planningIndicatorTypeMap).filter(i => i.isDefault == true);
            if (def.length > 0) {
                return def[0]
            } else {
                return null;
            }

        },
        orderedVlhTimeFrames() {
            return Object.values(this.vlhTimeFrameMap).sort((a, b) => {
                let dif = a.weekDays[0] - b.weekDays[0];
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                dif = this.$helpers.getMomentFromStringUTC(a.from, 'HH:mmZ')
                    - this.$helpers.getMomentFromStringUTC(b.from, 'HH:mmZ')
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                return 0;
            }).map(i => {
                let from = this.$helpers.getMomentFromStringUTC(i.from, 'HH:mmZ').format('HH:mm');
                let to = this.$helpers.getMomentFromStringUTC(i.to, 'HH:mmZ').format('HH:mm');

                return {
                    id: i.id,
                    name: i.name,
                    label: from + " - " + to,
                    weekDaysLabel: this.$helpers.formatWeekDayArray(i.weekDays),
                    value: i
                }
            });
        },
        vlhConfigForMainType() {
            let config = Object.values(this.vlhConfigMap).find(i => this.mainType != null && i.typeId == this.mainType.id);

            if (config != null) {
                return {
                    name: this.planningIndicatorTypeMap[config.secondaryTypeId].name,
                    label: config.avgBase.toFixed(2),
                    value: config
                }
            } else {
                return null;
            }
        },
        orderedVlhConversions() {

            return Object.values(this.vlhConversionMap).sort((a, b) => {
                let aN = this.spotMap[a.spotId] !== undefined ? this.spotMap[a.spotId].name : '';
                let bN = this.spotMap[b.spotId] !== undefined ? this.spotMap[b.spotId].name : '';
                return aN.localeCompare(bN);
            }).filter(a => this.mainType != null && a.typeId == this.mainType.id)
                .map(i => {
                    let from = this.$helpers.getMomentFromStringUTC(i.from, 'HH:mmZ').format('HH:mm');
                    let to = this.$helpers.getMomentFromStringUTC(i.to, 'HH:mmZ').format('HH:mm');

                    return {
                        id: i.id,
                        name: this.spotMap[i.spotId].name,
                        label: i.unitName + ' ' + Math.round(i.multiplier * 100).toFixed(2) + '%',
                        value: i
                    }
                });
        },
        spotItems() {
            return Object.values(this.spotMap).sort((a, b) => {
                let spotA = a.name.toLowerCase();
                let spotB = b.name.toLowerCase();
                if (spotA < spotB) {
                    return -1;
                } else if (spotA > spotB) {
                    return 1;
                } else {
                    return 0;
                }
            }).map(i => {
                return { label: i.name, value: i.id }
            });
        },
        timeItems() {
            return Object.values(this.vlhTimeFrameMap).sort((a, b) => {
                let dif = a.weekDays[0] - b.weekDays[0];
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                dif = this.$helpers.getMomentFromStringUTC(a.from, 'HH:mmZ')
                    - this.$helpers.getMomentFromStringUTC(b.from, 'HH:mmZ')
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                return 0;
            })
                .map(i => {
                    return { label: i.name, value: i.id, data: i }
                });
        },
        spotConversionMap() {
            let map = {};
            const mainTypeId = this.mainType ? this.mainType.id : null;
            Object.values(this.vlhConversionMap).filter(i => i.typeId === mainTypeId).forEach(i => {
                map[i.spotId] = i;
            });
            return map;
        },
        times() {
            return Object.values(this.vlhTimeFrameMap).sort((a, b) => {
                let dif = a.weekDays[0] - b.weekDays[0];
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                dif = this.$helpers.getMomentFromStringUTC(a.from, 'HH:mmZ')
                    - this.$helpers.getMomentFromStringUTC(b.from, 'HH:mmZ')
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                return 0;
            });
        },
        unitColorMap() {
            let unitColorMap = [];
            Object.values(this.spotMap).filter(spot => spot.isMain).forEach(spot => {
                unitColorMap[spot.unitId] = spot.color;
            });
            return unitColorMap;
        },
        lanes() {
            let view = this;

            let lanes = new Map;
            Object.values(this.businessUnitMap).forEach(businessUnit => {
                let lane = [];
                lane.name = businessUnit.name;
                lane.color = view.unitColorMap[businessUnit.id];
                lane.time = this.selectedTime;
                lane.unitId = businessUnit.id;
                lane.priority = businessUnit.priority;
                lanes.set(businessUnit.id, lane);
            });

            const mainTypeId = this.mainType ? this.mainType.id : null;
            let visibleSpots = view.filterDropdownOptions.filter(item => item.toggled).map(item => item.id);

            let filteredSpotMap = Object.values(this.spotMap)
                .filter(spot => visibleSpots.includes(spot.id)).sort((a, b) => {
                    return a.name.localeCompare(b.name);
                });

            Object.values(this.vlhTimeFrameMap).filter(tf => this.visibleTimeFrames.has(tf.id)).sort((a, b) => {
                let dif = a.weekDays[0] - b.weekDays[0];
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                dif = this.$helpers.getMomentFromStringUTC(a.from, 'HH:mmZ')
                    - this.$helpers.getMomentFromStringUTC(b.from, 'HH:mmZ')
                if (dif < 0) return -1;
                if (dif > 0) return 1;
                return 0;
            }).forEach(time => {
                filteredSpotMap.forEach(spot => {
                    let values = Object.values(this.vlhEmployeeThresholdMap).filter(i =>
                        i.typeId === mainTypeId && i.spotId === spot.id && i.timeId === time.id)
                        .sort((a, b) => {
                            return a.threshold - b.threshold;
                        })
                    if (values.length > 0) {
                        let state;

                        state = this.$helpers.GetDataTableStateFromObject({
                            typeId: '',
                            timeId: '',
                            spotId: '',
                            unitName: '',
                            threshold: 0,
                            employeeCount: 0
                        }, values);
                        state.headerMap['typeId'].sort = false;
                        state.headerMap['typeId'].label = this.$t('roster.view.keyFigure');
                        state.headerMap['typeId'].DisplayLabel = (i) => {
                            return this.planningIndicatorTypeMap[i.typeId].name
                        };

                        state.headerMap['spotId'].sort = false;
                        state.headerMap['spotId'].label = this.$tc('shift.main.position');
                        state.headerMap['spotId'].DisplayLabel = (i) => {
                            return this.spotMap[i.spotId].name
                        };

                        state.headerMap['unitName'].sort = false;
                        state.headerMap['unitName'].label = this.$t('indicator.vlh.unit');
                        state.headerMap['unitName'].DisplayLabel = (i) => {
                            return this.spotConversionMap[i.spotId] ? this.spotConversionMap[i.spotId].unitName : '-'
                        };

                        state.headerMap['timeId'].sort = false;
                        state.headerMap['timeId'].label = this.$t('shift.main.time');
                        state.headerMap['timeId'].DisplayLabel = (i) => {
                            return this.vlhTimeFrameMap[i.timeId].name
                        };

                        state.headerMap['threshold'].sort = false;
                        state.headerMap['threshold'].label = this.$t('indicator.meo.hourThreshold');
                        state.headerMap['threshold'].DisplayLabel = (i) => {
                            return ((i.threshold / Math.pow(10, this.mainType.fractional))*4.0).toFixed(2)
                        };


                        state.headerMap['employeeCount'].sort = false;
                        state.headerMap['employeeCount'].label = this.$t('global.general.employeeCount');

                        state.headerMap['actions'] = {
                            align: 'center',
                            button: {
                                icon: 'fas fa-plus',
                                action: ($event, data) => view.OpenCreateVlhEmployeeThresholdModal($event, time.id, spot.id)
                            },
                            buttons: [
                                {
                                    icon: 'fas fa-edit',
                                    action: ($event, data) => view.OpenEditVlhEmployeeThresholdModal($event, data)
                                },
                                {
                                    icon: 'fas fa-trash',
                                    action: ($event, data) => view.OpenDeleteVlhEmployeeThresholdModal($event, data)
                                },
                            ]
                        };
                        state.headerMap['actions'].width = '100px';
                        state.spot = spot.name;
                        state.spotId = spot.id;
                        state.timeId = time.id;
                        state.cardId = spot.id + time.id;
                        state.color = spot.color;
                        state.priority = spot.priority;

                        lanes.get(spot.unitId).push(state);
                    }
                })
            })

            return [...lanes.values()].filter(value => value.length > 0)
                .sort((a, b) => {
                    let val = Number(a.priority) - Number(b.priority);
                    return val !== 0 ? val : a.name.toUpperCase().localeCompare(b.name.toUpperCase());
                }).map(lane => lane.sort((a, b) => {
                    let val = Number(a.priority) - Number(b.priority);
                    return val !== 0 ? val : a.spot.toUpperCase().localeCompare(b.spot.toUpperCase());
                }))
        },
        spotArray() {
            return Object.values(this.spotMap).sort((a, b) => {
                let val = Number(this.businessUnitMap[a.unitId].priority) - Number(this.businessUnitMap[b.unitId].priority);
                if (val !== 0) {
                    return val;
                }
                val = Number(a.priority) - Number(b.priority);
                if (val !== 0) {
                    return val;
                }
                return val !== 0 ? val : a.name.toUpperCase().localeCompare(b.name.toUpperCase())
            });
        },
        vlhTableState() {
            let view = this;

            if (view.thresholdCurve === null) {
                return;
            }

            let state = {
                headerMap: [],
            };

            let columns = {};

            columns.date = '🕑';
            if (view.selectedTableMode === 2) {
                columns.date = '📅';

            }
            view.spotArray.forEach(sp => {
                columns[sp.id] = sp.name.substring(0,2).toUpperCase();
            });
            columns.actions = " ";

            let alphaV = '70'; // hex value, ff for full alpha
            let black = '#222222';
            let dark = '#404040';
            let fontColor = black; // 'white' looks better with full alpha
            let columnShrink = 7;
            let data = Object.values(view.buildThresholdCurveRows(Object.values(view.thresholdCurve), fontColor, alphaV));

            state = this.$helpers.GetDataTableStateFromKeyLabelObject(columns, data);

            state.headerMap.date.stylesHeader = {background: 'linear-gradient(to top, #404040 80%, var(--bg) 20%)', color: fontColor, padding: '0 5px'};
            state.headerMap.date.sort = false;
            state.headerMap.date.componentStateBuilders = [(data) => {
                let text = data.date;
                if (view.selectedTableMode === 2) {
                    text = this.$helpers.getMomentFromStringTZ(view.dateSelectionStart, "YYYY-MM-DDTHH:mmZ")
                        .format("DD")
                }
                return {
                    componentType: 'labelc',
                    state: {
                        text: text
                    },
                    styleLabel: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        background: '',
                        height: 'calc(100% - 10px)',
                        color: fontColor,
                        fontFamily: 'DistrictPro',
                        fontSize: '16px',
                        fontWeight: 'bold',
                    }
                }
            }];

            view.spotArray.forEach(sp => {
                state.headerMap[sp.id].stylesHeader = {background: view.unitColorMap[sp.unitId], color: fontColor, padding: '0 5px',
                borderLeft: columnShrink + 'px solid ' + dark, borderRight:  columnShrink + 'px solid ' + dark };
                state.headerMap[sp.id].sort = false;
                state.headerMap[sp.id].tooltip = sp.name;
                state.headerMap[sp.id].componentStateBuilders = [ (data) => {
                    let text = data[sp.id] !== undefined ? data[sp.id].workTime / 60 : 0;
                    if (view.selectedTableMode === 2) {
                        text = data[sp.id] !== undefined ? (data[sp.id].workTime / 1440).toFixed(2) : 0;
                    }
                     text = text !== 0 ? text : '';
                    return {
                        componentType: 'labelc',
                        state: {
                            text: text,
                        },
                        styleLabel: {
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            background: view.unitColorMap[sp.unitId] + alphaV,
                            color: fontColor,
                            height: '100%',
                            margin: columnShrink + 'px',
                            fontFamily: 'DistrictPro',
                            fontSize: '16px',
                            fontWeight: 400,
                        }
                    };
                } ];
            })

            state.headerMap.actions.stylesHeader = {background: 'linear-gradient(to top, #404040 80%, var(--bg) 20%)', padding: '0 5px'};
            state.headerMap.actions.stylesEntry = {'justify-content': 'center'};
            state.headerMap.actions.componentStateBuilders = [];

            let entries = Object.entries(state.headerMap);

            let mainColumns = ['date', 'actions'];
            view.spotArray.forEach(sp => {
                mainColumns.push(sp.id)
            })
            let columnWidth = 100 / (view.spotArray.length + 2);
            for (let x in entries) {
                if (mainColumns.includes(entries[x][0])) {
                    entries[x][1].width = columnWidth + '%';
                }
                entries[x][1].key = entries[x][0];
            }

            state.headerStyles = {fontSize: '18px', position: "sticky", top: 0, zIndex: 10, background: black,
                color: 'var(--default-label'};
            state.heightSubRow = 'fit-content';
            state.rowStyles = {fontSize: '14px', color: fontColor, background: 'var(--contrast-3)'};
            state.rowStylesCollapsed = {fontSize: '14px', background: 'var(--contrast-2)'};
            state.alterRowStylesCollapsed = {fontSize: '14px', background: 'var(--contrast-1)'};
            state.alwaysUnfold = false;
            return state;
        }
    },
    watch: {
        storeId: function (val, oldVal) {
            this.refresh(true);
        },
        selectedTime: function (val) {
            this.visibleTimeFrames.clear();
            this.visibleTimeFrames.add(val);
            this.visibleTimeFrames = new Set(this.visibleTimeFrames);
        },
        selectedTableMode: function (val) {
            this.getEmployeeThresholdQuarterHourCurve(this.dateSelectionStart,
                this.dateSelectionStart.clone().add(1, 'days'),
                this.mainType.id, true, val, true);
        }
    },
    // methods that implement data logic.
    methods: {
        refresh: function (force = false) {
            let view = this;
            this.loading = true;
            this.$helpers.GetVlhTimeFrameMap(force)
                .then(map => {
                    let times =
                        Object.values(map).sort((a, b) => {
                            let dif = a.weekDays[0] - b.weekDays[0];
                            if (dif < 0) return -1;
                            if (dif > 0) return 1;
                            dif = this.$helpers.getMomentFromStringUTC(a.from, 'HH:mmZ')
                                - this.$helpers.getMomentFromStringUTC(b.from, 'HH:mmZ')
                            if (dif < 0) return -1;
                            if (dif > 0) return 1;
                            return 0;
                        });
                    this.selectedTime = times.length > 0 ? times[0].id : null;
                    this.visibleTimeFrames = new Set([this.selectedTime]);
                    return view.$helpers.GetVlhConversionMap(force);
                })
                .then(map => {
                    return view.$helpers.GetVlhConfigMap(force);
                })
                .then(map => {
                    return view.$helpers.GetSpotMap(force);
                })
                .then(map => {
                    return view.$helpers.GetBusinessUnitMap(force);
                })
                .then(map => {
                    view.LoadFilterDropdown();
                    return view.$helpers.GetPlanningIndicatorTypeMap(force);
                }).then(map => {
                    return view.$helpers.GetVlhEmployeeThresholdMap(force);
                })
                .then(map => {
                    view.loading = false;
                })
                .catch(function (error) {
                    view.$helpers.error(view.$t('global.notifications.error'), view.$t('global.notifications.dataLoadingError'));
                    view.loading = false;
                    console.log(error)
                });
            view.showComponent = 'lanes';
        },
        getSpotsForUnit(unitId) {
            return Object.values(this.spotMap).filter(spot => spot.unitId === unitId);
        },
        checkOverlap(id, from, to, weekDays) {
            let checkFrom = from.clone();
            let checkTo = to.clone();
            if (checkTo <= checkFrom) {
                checkTo = checkTo.add(1, 'days');
            }
            let overlaps = new Set();
            Object.values(this.vlhTimeFrameMap).forEach(tf => {
                if (tf.id != id) {
                    //first check with same week days
                    let currentFrom = this.$helpers.getMomentFromStringUTC(tf.from, 'HH:mmZ')
                    let currentTo = this.$helpers.getMomentFromStringUTC(tf.to, 'HH:mmZ')

                    if (currentTo <= currentFrom) {
                        currentTo = currentTo.add(1, 'days');
                    }
                    let sameWeekDays = weekDays.filter(value => tf.weekDays.includes(value));
                    if (currentFrom < checkTo && currentTo > checkFrom && sameWeekDays.length > 0) {
                        overlaps.add(tf.name)
                    }

                    //then check if past midnight of previous days, if tf goes past midnight
                    let beforeFrom = this.$helpers.getMomentFromStringUTC(tf.from, 'HH:mmZ').add(-1, 'days')
                    let beforeTo = this.$helpers.getMomentFromStringUTC(tf.to, 'HH:mmZ').add(-1, 'days');

                    if (beforeTo <= beforeFrom) {
                        beforeTo = beforeTo.add(1, 'days');
                        sameWeekDays = weekDays.filter(value => tf.weekDays.includes(value - 1 < 1 ? 7 : value - 1));
                        if (beforeFrom < checkTo && beforeTo > checkFrom && sameWeekDays.length > 0) {
                            overlaps.add(tf.name)
                        }
                    }

                    //then check if past midnight of following days, checked tf goes past midnight


                    let afterFrom = this.$helpers.getMomentFromStringUTC(tf.from, 'HH:mmZ').add(1, 'days')
                    let afterTo = this.$helpers.getMomentFromStringUTC(tf.to, 'HH:mmZ').add(1, 'days');

                    if (afterTo <= afterFrom) {
                        afterTo = afterTo.add(1, 'days');
                    }
                    if (to <= from) {
                        sameWeekDays = weekDays.filter(value => tf.weekDays.includes(value + 1 > 7 ? 1 : value + 1));
                        if (afterFrom < checkTo && afterTo > checkFrom && sameWeekDays.length > 0) {
                            overlaps.add(tf.name)
                        }
                    }


                }


            })


            return Array.from(overlaps);
        },
        OpenFilterDropdown($event) {
            var view = this;
            let target;
            if ($event != undefined) target = $event.currentTarget;


            this.$helpers.OpenPopup({
                elRelative: target,
                type: 'list',
                componentState: {
                    entries: view.filterDropdownOptions,
                },
                remainAfterSelect: true,
                pointerDirection: -1,
                iconsLeft: true,
                selectCallback: function ($event, item, dropdown) {
                    item.toggled = !item.toggled;

                    if (item.all) {
                        view.filterDropdownOptions.forEach(option => {
                            option.toggled = item.toggled;
                        })
                    }

                    view.filterDropdownOptions = view.filterDropdownOptions.slice();
                },
            });
        },
        setDateSelection(date) {
            this.dateSelectionStart = this.$helpers.getMomentTZ().year(date.year()).month(date.month())
                .date(date.date()).startOf('day');

            this.getEmployeeThresholdQuarterHourCurve(this.dateSelectionStart,
                this.dateSelectionStart.clone().add(1, 'days'),
                this.mainType.id, true, this.selectedTableMode, true);
        },
        OpenDateSelection($event){
            let view = this;
            this.$helpers.OpenDatepickerPopup(
                { viewsEnabled: ['D'], date: this.dateSelectionStart.clone() },
                {
                    OnDateSelect: (date) => { view.setDateSelection(date) },
                },
                { elRelative: $event ? $event.currentTarget : null });
        },
        buildThresholdCurveRows(curve, fontColor, alphaV) {
            let rows = [];

            // pad times with no entries
            Array.from({ length: 23 }, (_, i) => (i + 1).toString().padStart(2, '0') + ':').forEach(time => {
                rows[time] = { date: time, stubEntries: [], subEntries: [] }
            })

            if (this.selectedTableMode === 0) {

                Object.values(curve).forEach(th => {
                    let time = this.$helpers.getMomentFromStringTZ(th.date, "YYYY-MM-DDTHH:mmZ")
                        .format("HH:");
                    let subTime = this.$helpers.getMomentFromStringTZ(th.date, "YYYY-MM-DDTHH:mmZ")
                        .format("HH:mm");

                    if (rows[time] === undefined) {
                        rows[time] = { date: time, stubEntries: [], subEntries: [] };
                    }
                    if (rows[time].stubEntries[subTime] === undefined) {
                        rows[time].stubEntries[subTime] = {};
                        rows[time].stubEntries[subTime].subTime = subTime;
                        rows[time].stubEntries[subTime].time = time;
                    }
                    if (rows[time][th.spotId] === undefined) {
                        rows[time][th.spotId] = { workTime: 0};
                    }

                    rows[time].stubEntries[subTime][th.spotId] = th.workTime;
                    rows[time][th.spotId].workTime += th.workTime;
                });
                Object.values(rows).forEach(r => {
                    Object.values(r.stubEntries).forEach((se, index) => {
                        let columns = {};
                        Object.values(this.spotArray).forEach(sp => {
                            columns[sp.id] = { workTime: se[sp.id] !== undefined ? se[sp.id] / 15 : 0, color: this.unitColorMap[sp.unitId] + alphaV };
                        })

                        let subEntry = {componentOverride: 'vlhThresholdCurveRow',
                            componentStateBuilders: [() => {
                                return {
                                    color: fontColor,
                                    index: index,
                                    curve: columns,
                                    subTime: se.subTime,
                                    componentType: 'vlhThresholdCurveRow',
                                }
                            }]
                        }
                        rows[se.time].subEntries.push(subEntry);
                    })
                })
                return rows;
            }
            if (this.selectedTableMode === 1) {
                Object.values(curve).forEach(th => {
                    let time = this.$helpers.getMomentFromStringTZ(th.date, "YYYY-MM-DDTHH:mmZ")
                        .format("HH:");

                    if (rows[time] === undefined) {
                        rows[time] = { date: time };
                    }
                    if (rows[time][th.spotId] === undefined) {
                        rows[time][th.spotId] = { workTime: 0 };
                    }

                    rows[time][th.spotId].workTime += th.workTime;
                });
                return rows;
            }
            if (this.selectedTableMode === 2) {
                let time;
                rows = [];

                Object.values(curve).forEach(th => {
                    if (time === undefined) {
                        time = this.$helpers.getMomentFromStringTZ(th.date, "YYYY-MM-DDTHH:mmZ")
                            .format("DD:");
                    }

                    if (rows[time] === undefined) {
                        rows[time] = { date: time };
                    }
                    if (rows[time][th.spotId] === undefined) {
                        rows[time][th.spotId] = { workTime: 0 };
                    }

                    rows[time][th.spotId].workTime += th.workTime;
                });
                return rows;
            }

            return rows;
        },
        LoadFilterDropdown() {

            let filterDropdownOptions = [];
            Object.values(this.spotMap).sort((a, b) => {
                let aMainSpot = Object.values(this.spotMap).find(spot => spot.unitId == a.unitId && spot.isMain);
                let bMainSpot = Object.values(this.spotMap).find(spot => spot.unitId == b.unitId && spot.isMain);
                if (aMainSpot.id == bMainSpot.id) {
                    if (a.isMain && !b.isMain) {
                        return -1;
                    } else if (!a.isMain && b.isMain) {
                        return 1;
                    } else {
                        return a.priority - b.priority;
                    }
                } else {
                    return aMainSpot.priority - bMainSpot.priority
                }

            }).forEach(function (spot) {
                let option = {
                    label: spot.name,
                    toggled: true,
                    color: spot.color,
                    id: spot.id,
                    isMain: spot.isMain,
                    unitId: spot.unitId,
                    bold: spot.isMain
                };
                filterDropdownOptions.push(option);
            });

            filterDropdownOptions.push({ label: this.$t('global.ui.all'), toggled: true, all: true, color: "#eeeeee", id: -1 });
            this.filterDropdownOptions = filterDropdownOptions;
        },
        OpenCreateVlhTimeFrameModal() {
            let view = this;

            view.$helpers.OpenPopup({
                //elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: '' },
                        {
                            label: this.$t('global.general.from'),
                            key: 'from',
                            hidden: false,
                            type: 'timeframe',
                            value: this.$helpers.getMomentUTC().startOf('day')
                        },
                        {
                            label: this.$t('global.general.to'),
                            key: 'to',
                            hidden: false,
                            type: 'timeframe',
                            value: this.$helpers.getMomentUTC().startOf('day')
                        },
                        {
                            label: this.$tc('store.settings.weekdays', 2), key: 'weekDays', hidden: false, type: 'togglelist', toggleEntries: [
                                { label: this.$t('store.openingHours.weekDay1Short'), value: 1, selected: true },
                                { label: this.$t('store.openingHours.weekDay2Short'), value: 2, selected: true },
                                { label: this.$t('store.openingHours.weekDay3Short'), value: 3, selected: true },
                                { label: this.$t('store.openingHours.weekDay4Short'), value: 4, selected: true },
                                { label: this.$t('store.openingHours.weekDay5Short'), value: 5, selected: true },
                                { label: this.$t('store.openingHours.weekDay6Short'), value: 6, selected: true },
                                { label: this.$t('store.openingHours.weekDay7Short'), value: 7, selected: true },
                            ]
                        },
                    ],
                    errorCheck: [
                        (entries) => {

                            let overlaps = view.checkOverlap(entries.id, entries.from, entries.to, entries.weekDays);


                            if (overlaps.length > 0) {
                                return {
                                    key: 'from',
                                    type: 'error',
                                    label: this.$t('shift.groups.overlap'),
                                    text: this.$t('indicator.vlh.timePeriodOverlap') + overlaps[0] + '"!'
                                }
                            } else if (entries.name == '') {
                                return {
                                    key: 'name',
                                    type: 'error',
                                    label: this.$t('pages.employeeData.name'),
                                    text: this.$t('global.notifications.enterName')
                                }

                            } else {
                                return null;
                            }
                        },
                    ],
                    selectCallback: function (data) {
                        view.createVlhTimeFrame(data);

                    }
                },
                header: this.$t('indicator.vlh.newTimeFrame'),
                centered: true,
                expanded: true,
            });
        },
        createVlhTimeFrame: function (item) {
            let view = this;
            let url = '/api/sec/vlhtimeframe';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                name: item.name,
                from: item.from.format('HH:mm'),
                to: item.to.format('HH:mm'),
                weekDays: item.weekDays
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setVlhTimeFrameMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.timeFrameAdded'));
                let firstEntry = view.times[0].id;
                view.selectedTime = firstEntry ? firstEntry : {};
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), 'Fehler beim Erstellen der Zeit');
                console.log(error)
            })

        },

        OpenDeleteVlhTimeFrameModal(data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('indicator.vlh.deleteTimeFrame'),
                description: this.$t('indicator.vlh.deleteTimeFrameHelp', [data.name]),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deleteVlhTimeFrame(data);
                }
            });
        },
        deleteVlhTimeFrame: function (item) {
            let view = this;
            let url = '/api/sec/vlhtimeframe';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteVlhTimeFrameMapEntry", { id: item.id });
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.timeFrameDeleted'));
                this.selectedTime = this.times.length > 0 ? this.times[0].id : {};
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.deleteTimeFrameError'));
                console.log(error)
            })

        },
        OpenEditVlhTimeFrameModal(item) {
            let view = this;
            let from = this.$helpers.getMomentUTC().startOf('day');
            if (item.from) {
                from = this.$helpers.getMomentFromStringUTC(item.from, 'HH:mmZ');
            }
            let to = this.$helpers.getMomentUTC().endOf('day');
            if (item.to) {
                to = this.$helpers.getMomentFromStringUTC(item.to, 'HH:mmZ');
            }
            this.$helpers.OpenPopup({
                //elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id },
                        { label: this.$t('pages.employeeData.name'), key: 'name', hidden: false, type: 'text', value: item.name },
                        { label: this.$t('global.general.from'), key: 'from', hidden: false, type: 'timeframe', value: from },
                        { label: this.$t('global.general.to'), key: 'to', hidden: false, type: 'timeframe', value: to },
                        {
                            label: this.$tc('store.settings.weekdays', 2), key: 'weekDays', hidden: false, type: 'togglelist', toggleEntries: [
                                { label: 'Mo', value: 1, selected: item.weekDays.includes(1) },
                                { label: 'Di', value: 2, selected: item.weekDays.includes(2) },
                                { label: 'Mi', value: 3, selected: item.weekDays.includes(3) },
                                { label: 'Do', value: 4, selected: item.weekDays.includes(4) },
                                { label: 'Fr', value: 5, selected: item.weekDays.includes(5) },
                                { label: 'Sa', value: 6, selected: item.weekDays.includes(6) },
                                { label: 'So', value: 7, selected: item.weekDays.includes(7) },
                            ]
                        },
                    ],
                    errorCheck: [
                        (entries) => {

                            let overlaps = view.checkOverlap(entries.id, entries.from, entries.to, entries.weekDays);


                            if (overlaps.length > 0) {
                                return {
                                    key: 'from',
                                    type: 'error',
                                    label: this.$t('shift.groups.overlap'),
                                    text: this.$t('indicator.vlh.timePeriodOverlap') + overlaps[0] + '"!'
                                }
                            } else if (entries.name == '') {
                                return {
                                    key: 'name',
                                    type: 'error',
                                    label: this.$t('pages.employeeData.name'),
                                    text: this.$t('global.notifications.enterName')
                                }

                            } else {
                                return null;
                            }
                        },
                    ],
                    selectCallback: function (data) {
                        view.editVlhTimeFrame(data);

                    },

                },
                header: this.$t('indicator.vlh.editTimeFrame'),
                centered: true,
                expanded: true,
            });
        },
        editVlhTimeFrame: function (item) {
            let view = this;
            let url = '/api/sec/vlhtimeframe';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                name: item.name,
                from: item.from.format('HH:mm'),
                to: item.to.format('HH:mm'),
                weekDays: item.weekDays,
                updateFields: ["from", "to", "name", "weekDays"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.vlhTimeFrameMap[item.id]
                data.from = payload.from;
                data.to = payload.to;
                data.weekDays = payload.weekDays;

                view.$store.commit("setVlhTimeFrameMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.timeFrameEdited'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.editTimeFrameError'));
                console.log(error)
            })

        },


        OpenCreateVlhConversionModal() {
            let view = this;

            let spotitems = Object.values(view.spotMap).sort((a, b) => a.name.localeCompare(b.name))
                .map(i => {
                    return { label: i.name, value: i.id, data: i }
                });

            view.$helpers.OpenPopup({
                //elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {
                            label: this.$tc('shift.main.position'),
                            key: 'spotId',
                            hidden: false,
                            type: 'dropdownsearch',
                            value: null,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: spotitems,
                                selectMultiple: false,
                                selectedItems: [],
                                selectFirst: true,
                                styleLight: true,
                            }
                        },
                        { label: this.$t('indicator.vlh.unit'), key: 'unitName', hidden: false, type: 'text', value: '' },
                        {
                            label: this.$t('indicator.vlh.percent'),
                            key: 'multiplier',
                            hidden: false,
                            type: 'slider',
                            value: 100,
                            min: 1,
                            max: 100,
                            slider: {
                                hideMin: true,
                                hideMax: true,
                                min: 1,
                                max: 100,
                                value: 100,
                                step: 1,
                                DisplayLabel: (val) => { return val + "%"},
                                inputControl: true,
                                sliderInput: (x) => {return x},
                                labelToInt: (x) => {return x.slice(0, -1)},
                            }
                        },
                    ],
                    errorCheck: [
                        (entries) => {

                            let overlaps = Object.values(view.vlhConversionMap).find(i => i.spotId == entries.spotId && i.typeId == view.mainType.id);


                            if (overlaps != null) {
                                return {
                                    key: 'from',
                                    type: 'error',
                                    label: this.$t('shift.groups.overlap'),
                                    text: this.$t('indicator.vlh.unitExists')
                                }
                            } else if (entries.unitName == '') {
                                return {
                                    key: 'unitName',
                                    type: 'error',
                                    label: this.$t('indicator.vlh.unit'),
                                    text: this.$t('indicator.vlh.pleaseEnterName')
                                }

                            } else {
                                return null;
                            }
                        },
                    ],

                    selectCallback: function (data) {
                        view.createVlhConversion(data);

                    }
                },
                header: this.$t('indicator.vlh.newUnit'),
                width: "600px",
                centered: true,
                expanded: true,
            });
        },
        createVlhConversion: function (item) {
            let view = this;
            let url = '/api/sec/vlhconversion';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                spotId: item.spotId,
                typeId: this.mainType.id,
                unitName: item.unitName,
                multiplier: item.multiplier / 100.0
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setVlhConversionMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.unitAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.addUnitError'));
                console.log(error)
            })

        },

        OpenDeleteVlhConversionModal(data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('indicator.vlh.deleteUnit'),
                description: this.$t('indicator.vlh.deleteUnitQuery', [view.spotMap[data.spotId].name]),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deleteVlhConversion(data);
                }
            });
        },
        deleteVlhConversion: function (item) {
            let view = this;
            let url = '/api/sec/vlhconversion';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteVlhConversionMapEntry", { id: item.id });
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.unitDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.deleteUnitError'));
                console.log(error)
            })

        },
        OpenEditVlhConversionModal(item) {
            let view = this;
            let val = Math.round(item.multiplier * 100);
            this.$helpers.OpenPopup({
                //elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id },
                        { label: this.$t('indicator.vlh.unit'), key: 'unitName', hidden: false, type: 'text', value: item.unitName },
                        {
                            label: this.$t('indicator.vlh.percent'),
                            key: 'multiplier',
                            hidden: false,
                            type: 'slider',
                            value: val,
                            min: 1,
                            max: 100,
                            slider: {
                                hideMin: true,
                                hideMax: true,
                                min: 1,
                                max: 100,
                                value: val,
                                step: 1,
                                DisplayLabel: (val) => { return val + "%"},
                                inputControl: true,
                                sliderInput: (x) => {return x},
                                labelToInt: (x) => {return x.slice(0, -1)},
                            }
                        },
                    ],
                    errorCheck: [
                        (entries) => {
                            if (entries.unitName == '') {
                                return {
                                    key: 'unitName',
                                    type: 'error',
                                    label: this.$t('indicator.vlh.unit'),
                                    text: this.$t('indicator.vlh.pleaseEnterName')
                                }

                            } else {
                                return null;
                            }
                        },
                    ],
                    selectCallback: function (data) {
                        view.editVlhConversion(data);

                    },

                },
                header: this.$t('indicator.vlh.editUnit'),
                width: "600px",
                centered: true,
                expanded: true,
            });
        },
        editVlhConversion: function (item) {
            let view = this;
            let url = '/api/sec/vlhconversion';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                unitName: item.unitName,
                multiplier: item.multiplier / 100.0,
                updateFields: ["unitName", "multiplier"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.vlhConversionMap[item.id]
                data.unitName = payload.unitName;
                data.multiplier = payload.multiplier;

                view.$store.commit("setVlhConversionMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.unitEdited'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.editUnitError'));
                console.log(error)
            })

        },


        OpenCreateVlhConfigModal() {
            let view = this;

            let typeitems = Object.values(view.planningIndicatorTypeMap).filter(i => i.id != view.mainType.id).sort((a, b) => a.name.localeCompare(b.name))
                .map(i => {
                    return { label: i.name, value: i.id, data: i }
                });

            view.$helpers.OpenPopup({
                //elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        {
                            label: this.$t('indicator.vlh.keyFigureForAdjustment'),
                            key: 'secondaryTypeId',
                            hidden: false,
                            type: 'dropdownsearch',
                            value: null,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: typeitems,
                                selectMultiple: false,
                                selectedItems: [],
                                selectFirst: true,
                                styleLight: true,
                            }
                        },
                        { label: this.$t('indicator.vlh.averageBaseValue'), key: 'avgBase', hidden: false, type: 'text', value: 0 },

                    ],
                    errorCheck: [
                        (entries) => {

                            let avgBase = parseFloat(("" + entries.avgBase).replace(',', '.'))


                            if (isNaN(avgBase)) {
                                return {
                                    key: 'avgBase',
                                    type: 'error',
                                    label: this.$t('indicator.vlh.averageBaseValue'),
                                    text: this.$t('indicator.vlh.pleaseEnterValidNumber')
                                }
                            } else if (entries.secondaryTypeId == null) {
                                return {
                                    key: 'secondaryTypeId',
                                    type: 'error',
                                    label: this.$t('indicator.vlh.keyFigureForAdjustment'),
                                    text: this.$t('indicator.vlh.pleaseSelectKeyFigure')
                                }

                            } else {
                                return null;
                            }
                        },
                    ],

                    selectCallback: function (data) {
                        view.createVlhConfig(data);

                    }
                },
                header: this.$t('indicator.vlh.newVLhDependency'),
                centered: true,
                expanded: true,
            });
        },
        createVlhConfig: function (item) {
            let view = this;
            let url = '/api/sec/vlhconfig';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                typeId: this.mainType.id,
                secondaryTypeId: item.secondaryTypeId,
                avgBase: parseFloat(("" + item.avgBase).replace(',', '.'))
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setVlhConfigMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.dependencyAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.addDependencyError'));
                console.log(error)
            })

        },

        OpenDeleteVlhConfigModal(data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('indicator.vlh.deleteDependency'),
                description: this.$t('indicator.vlh.deleteDependencyQuery', [view.planningIndicatorTypeMap[data.secondaryTypeId].name]),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deleteVlhConfig(data);
                }
            });
        },
        deleteVlhConfig: function (item) {
            let view = this;
            let url = '/api/sec/vlhconfig';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteVlhConfigMapEntry", { id: item.id });
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.dependencyDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.deleteDependencyError'));
                console.log(error)
            })

        },
        OpenEditVlhConfigModal(item) {
            let view = this;

            let typeitems = Object.values(view.planningIndicatorTypeMap).filter(i => i.id != view.mainType.id).sort((a, b) => a.name.localeCompare(b.name))
                .map(i => {
                    return { label: i.name, value: i.id, data: i }
                });

            let selectedTypeItem = typeitems.find(i => i.value == item.secondaryTypeId);

            this.$helpers.OpenPopup({
                //elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id },
                        {
                            label: this.$t('indicator.vlh.keyFigureForAdjustment'),
                            key: 'secondaryTypeId',
                            hidden: false,
                            type: 'dropdownsearch',
                            value: selectedTypeItem.secondaryTypeId,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: typeitems,
                                selectMultiple: false,
                                selectedItems: [selectedTypeItem],
                                selectedItem: selectedTypeItem,
                                selectFirst: false,
                                styleLight: true,
                            }
                        },
                        {
                            label: this.$t('indicator.vlh.averageBaseValue'),
                            key: 'avgBase',
                            hidden: false,
                            type: 'text',
                            value: item.avgBase
                        },
                    ],
                    errorCheck: [
                        (entries) => {
                            let avgBase = parseFloat(("" + entries.avgBase).replace(',', '.'))


                            if (isNaN(avgBase)) {
                                return {
                                    key: 'avgBase',
                                    type: 'error',
                                    label: this.$t('indicator.vlh.averageBaseValue'),
                                    text: this.$t('indicator.vlh.pleaseEnterValidNumber')
                                }
                            } else if (entries.secondaryTypeId == null) {
                                return {
                                    key: 'secondaryTypeId',
                                    type: 'error',
                                    label: this.$t('indicator.vlh.keyFigureForAdjustment'),
                                    text: this.$t('indicator.vlh.pleaseSelectKeyFigure')
                                }

                            } else {
                                return null;
                            }
                        },
                    ],
                    selectCallback: function (data) {
                        view.editVlhConfig(data);

                    },

                },
                header: this.$t('indicator.vlh.editDependency'),
                centered: true,
                expanded: true,
            });
        },
        editVlhConfig: function (item) {
            let view = this;
            let url = '/api/sec/vlhconfig';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                secondaryTypeId: item.secondaryTypeId,
                avgBase: parseFloat(("" + item.avgBase).replace(',', '.')),
                updateFields: ["secondaryTypeId", "avgBase"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.vlhConfigMap[item.id]
                data.secondaryTypeId = payload.secondaryTypeId;
                data.avgBase = payload.avgBase;

                view.$store.commit("setVlhConfigMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.dependencyEdited'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.editDependencyError'));
                console.log(error)
            })

        },
        OpenCreateVlhEmployeeThresholdModal($event, timeId = null, spotId = null) {
            let view = this;
            let unit = (this.mainType.unit != null && this.mainType.unit !== '') ? '(' + this.mainType.unit + ')' : '';

            let selectedTimeItem = timeId == null ? null : this.timeItems.find(i => i.value === timeId);
            let selectedSpotItem = spotId == null ? null : this.spotItems.find(i => i.value === spotId);

            let spotIdIsArray = Object.prototype.toString.call(spotId) === '[object Array]';
            let spotDrownDownItems = this.spotItems;
            if (spotIdIsArray) {
                spotDrownDownItems = spotId.map(spot => ({
                    value: spot.id, label: spot.name
                }))
            }

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: true, type: 'text', value: this.mainType.id },
                        {
                            label: this.$t('shift.main.time'),
                            key: 'timeId',
                            hidden: false,
                            disabled: timeId != null,
                            type: 'dropdownsearch',
                            value: null,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: this.timeItems,
                                selectMultiple: false,
                                selectedItems: selectedTimeItem == null ? [] : [selectedTimeItem],
                                selectedItem: selectedTimeItem,
                                selectFirst: timeId == null ? true : false,
                                styleLight: true,
                            }
                        },
                        {
                            label: this.$tc('shift.main.position'),
                            key: 'spotId',
                            hidden: false,
                            disabled: spotId != null && !spotIdIsArray,
                            type: 'dropdownsearch',
                            value: null,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: spotDrownDownItems,
                                selectMultiple: false,
                                selectedItems: selectedSpotItem == null ? [] : [selectedSpotItem],
                                selectedItem: selectedSpotItem,
                                selectFirst: spotId == null ? true : false,
                                styleLight: true,
                            }
                        },
                        { label: this.$t('indicator.meo.hourThreshold') + ' ' + unit, key: 'threshold', hidden: false, type: 'numeric', value: 0 },

                        {
                            label: this.$t('global.general.employeeCount'),
                            key: 'employeeCount',
                            hidden: false,
                            type: 'numeric',
                            value: 0,
                            min: 0
                        },
                    ],
                    selectCallback: function (indicatorType) {
                        view.createVlhEmployeeThreshold(indicatorType);
                    }
                },
                header: this.$t('indicator.vlh.newValueFor') + ' ' + this.mainType.name,
                centered: true,
                expanded: true,
            });
        },
        createVlhEmployeeThreshold: function (item) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold';
            let params = {
                storeId: this.storeId,
            }


            let payload = {
                storeId: this.storeId,
                typeId: item.typeId,
                spotId: item.spotId,
                threshold: Math.round((item.threshold/4.0) * Math.pow(10, this.mainType.fractional)),
                employeeCount: item.employeeCount,
                timeId: item.timeId
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.$store.commit("setVlhEmployeeThresholdMapEntry", response.data.data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.valueAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.addValueError'));
                console.log(error)
            })

        },
        OpenCreateMultipleVlhEmployeeThresholdModal($event) {
            let view = this;
            let entries = [];

            let unit = (this.mainType.unit != null && this.mainType.unit != '') ? '(' + this.mainType.unit + ')' : '';
            entries.push({ label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: true, type: 'text', value: this.mainType.id });
            entries.push({
                label: this.$t('shift.main.time'),
                key: 'timeId',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                selectMultiple: false,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: this.timeItems,
                    selectMultiple: false,
                    selectedItems: [],
                    selectFirst: true,
                    styleLight: true,
                }
            })
            entries.push({ label: this.$t('indicator.meo.hourThreshold') + ' ' + unit, key: 'threshold', hidden: false, type: 'numeric', value: 0 });
            entries.push({ divider: true });
            Object.values(this.spotMap).sort((a, b) => {
                if (a.name < b.name) {
                    return -1;
                }
                if (a.name > b.name) {
                    return 1;
                }
                return 0;
            }).forEach(spot => {
                let key = spot.id;
                let label = spot.name + " " + this.$t('indicator.meo.empShort');
                entries.push({ label: label, key: key, hidden: false, type: 'numeric', value: 0, min: 0 })

            })

            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: entries,
                    selectCallback: function (item) {
                        let requests = [];
                        Object.values(view.spotMap).forEach(spot => {
                            let key = spot.id;
                            if (item[key] > 0) {
                                requests.push({
                                    typeId: item.typeId,
                                    threshold: item.threshold,
                                    timeId: item.timeId,
                                    spotId: spot.id,
                                    employeeCount: item[key]
                                });
                            }

                        });
                        if (requests.length > 0) {
                            view.createMultipleVlhEmployeeThreshold(requests);
                        }

                    }
                },
                header: this.$t('indicator.vlh.newValueFor') + ' ' + this.mainType.name,
                centered: true,
                expanded: true,
            });
        },
        createMultipleVlhEmployeeThreshold: function (items) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold/multiple';
            let params = {
                storeId: this.storeId,
            }

            let payload = {
                requests: []
            }
            items.forEach(item => {
                let o = {
                    storeId: this.storeId,
                    typeId: item.typeId,
                    spotId: item.spotId,
                    timeId: item.timeId,
                    threshold: Math.round((item.threshold/4.0) * Math.pow(10, this.mainType.fractional)),
                    employeeCount: item.employeeCount
                };
                payload.requests.push(o);
            })


            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                view.refresh(true);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.valuesAdded'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.addValueError'));
                console.log(error)
            })

        },

        OpenDeleteVlhEmployeeThresholdModal($event, data) {
            let view = this;
            view.$helpers.OpenAlert({
                header: this.$t('indicator.vlh.deleteValue'),
                description: this.$t('indicator.vlh.deleteValueQuery'),
                callbackAccept: (alert) => {
                    alert.hidden = true;
                    view.deleteVlhEmployeeThreshold(data);
                }
            });
        },
        deleteVlhEmployeeThreshold: function (item) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold';
            let params = {
                id: item.id,
                storeId: this.storeId,
            }


            this.axios({
                method: 'delete',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                params: params,
                url: url
            }).then(response => {
                view.$store.commit("deleteVlhEmployeeThresholdMapEntry", { id: item.id });
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.valueDeleted'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.deleteValueError'));
                console.log(error)
            })

        },
        OpenEditVlhEmployeeThresholdModal($event, item) {
            let view = this;
            let tvalue = (item.threshold*4.0) / Math.pow(10, this.mainType.fractional);
            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [
                        { label: 'Id', key: 'id', hidden: true, type: 'text', value: item.id },
                        { label: this.$t('indicator.meo.hourThreshold'), key: 'threshold', hidden: false, type: 'numeric', value: tvalue },

                        {
                            label: this.$t('global.general.employeeCount'),
                            key: 'employeeCount',
                            hidden: false,
                            type: 'numeric',
                            value: item.employeeCount,
                            min: 0
                        },
                    ],
                    selectCallback: function (item) {
                        view.editVlhEmployeeThreshold(item);
                    },

                },
                header: this.$t('indicator.vlh.editValue'),
                centered: true,
                expanded: true,
            });
        },
        editVlhEmployeeThreshold: function (item) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                id: item.id,
                threshold: (item.threshold/4.0) * Math.pow(10, this.mainType.fractional),
                employeeCount: item.employeeCount,
                updateFields: ["threshold", "employeeCount"]
            };

            this.axios({
                method: 'put',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                let data = view.vlhEmployeeThresholdMap[item.id]
                data.threshold = payload.threshold;
                data.employeeCount = payload.employeeCount;

                view.$store.commit("setVlhEmployeeThresholdMapEntry", data);
                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.valueEdited'));
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.editValueError'));
                console.log(error)
            })

        },
        openDeleteConfirmAlert() {
            let view = this;
            let description = this.$t('indicator.vlh.deleteAllData');

            view.$helpers.OpenAlert({
                header: this.$t('indicator.vlh.confirmDelete'),
                description: description,
                callbackAccept: function (popup) {
                    let ids = [];
                    Object.values(view.vlhEmployeeThresholdMap).forEach(item => {
                        if (item.typeId == view.mainType.id) {
                            ids.push(item.id);
                        }
                    })
                    if (ids.length > 0) {
                        view.deleteMultipleEmployeeThreshold(ids);
                    } else {
                        view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.couldNotDeleteData'));
                    }
                    popup.hidden = true;
                }, callbackCancel: function (popup) {
                    popup.loading = false;
                    popup.hidden = true;
                }
            });
        },
        deleteMultipleEmployeeThreshold: function (ids) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold/any/delete';
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                ids: ids,
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {

                view.$helpers.success(view.$t('global.notifications.success'), view.$t('indicator.vlh.dataDeleted'));
                view.refresh(true);
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.vlh.deleteDataError'));
                console.log(error)
            })

        },
        OpenReverseVlhEmployeeThresholdModal($event) {
            let view = this;
            let entries = [];

            let modeItems = [ { label: this.$t('store.settings.average'), value: 1 }, { label: "Minimum", value: 2 }, {
                label: this.$t('roster.main.max'),
                value: 2
            } ];
            let plannedItems = [ {
                label: this.mainType.name + this.$t('indicator.vlh.targetBubbleCaps'),
                value: true
            }, { label: this.mainType.name + this.$t('roster.comp.actualBubble'), value: false } ];
            let spotItems = Object.values(this.spotMap).map(spot => {
                return { label: spot.name, value: spot.id, selected: true }
            });

            let from = this.$helpers.getMomentTZ().startOf('month');
            let to = from.clone().add(1, 'months');
            if (this.rosterFromTo != null) {
                from = this.$helpers.getMomentFromValuesTZ(this.rosterFromTo.year, this.rosterFromTo.month, 1);
                to = from.clone().add(1, 'months');
            }


            entries.push({ label: this.$t('roster.view.keyFigure'), key: 'typeId', hidden: true, type: 'text', value: this.mainType.id });
            entries.push({ label: this.$t('shift.main.time'), key: 'timeId', hidden: true, type: 'text', value: this.selectedTime });
            entries.push({
                label: this.$t('global.general.fromDay'),
                key: 'from',
                hidden: false,
                type: 'date',
                value: from,
                flexGroup: true,
                styles: { 'margin-right': '10px' }
            });
            entries.push({ label: this.$t('global.general.toDay'), key: 'to', hidden: false, type: 'date', value: to, flexGroup: true });
            entries.push({
                label: this.$tc('store.structure.spot', 2),
                key: 'spotIds',
                hidden: false,
                type: 'dropdownsearch',
                value: null,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: spotItems,
                    selectMultiple: true,
                    selectedItems: spotItems.filter(item => item.selected),
                    styleLight: true,
                }
            });
            entries.push({
                label: this.$t('roster.view.keyFigure'),
                key: 'planned',
                hidden: false,
                type: 'dropdownsearch',
                value: true,
                dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: plannedItems,
                    selectMultiple: false,
                    selectedItems: [],
                    selectFirst: true,
                    styleLight: true,
                }
            });
            entries.push({
                label: this.$t('indicator.meo.mode'), key: 'mode', hidden: false, type: 'dropdownsearch', value: 1, dropdownSearchState: {
                    toggled: false,
                    displayedItems: [],
                    input: '',
                    items: modeItems,
                    selectMultiple: false,
                    selectedItems: [],
                    selectFirst: true,
                    styleLight: true,
                }
            });
            entries.push({
                label: this.$t('indicator.meo.interval'), key: 'bucketSize', hidden: false, value: 10,
                slider: {
                    min: 1,
                    max: 500,
                    hideMin: true,
                    hideMax: true,
                    value: 10,
                    step: 1,
                }
            })
            entries.push({ label: this.$t('indicator.meo.minThreshold') + ' ', key: 'minThreshold', hidden: false, type: 'numeric', value: null });
            entries.push({ label: this.$t('indicator.meo.maxThreshold') + ' ', key: 'maxThreshold', hidden: false, type: 'numeric', value: null });


            view.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: entries,
                    errorCheck: [
                        (entries) => {

                            if (entries['from'] >= entries['to']) {
                                return {
                                    key: 'from',
                                    type: 'error',
                                    label: this.$t('global.general.fromDay'),
                                    text: this.$t('indicator.meo.startBeforeEnd')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries.to.diff(entries.from, 'days') > 32) {
                                return {
                                    key: 'to',
                                    type: 'error',
                                    label: this.$t('global.general.toDay'),
                                    text: this.$t('indicator.meo.interval31warn')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries['spotIds'] == null || entries['spotIds'].length == 0) {
                                return {
                                    key: 'spotIds',
                                    type: 'error',
                                    label: this.$tc('shift.main.position', 2),
                                    text: this.$t('roster.main.selectBusinessUnitPlease')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries['minThreshold'] != null && isNaN(entries['minThreshold'])) {
                                return {
                                    key: 'minThreshold',
                                    type: 'error',
                                    label: this.$t('indicator.meo.minThreshold'),
                                    text: this.$t('indicator.meo.pleaseEnterNumber')
                                }
                            } else {
                                return null
                            }
                        },
                        (entries) => {

                            if (entries['maxThreshold'] != null && isNaN(entries['maxThreshold'])) {
                                return {
                                    key: 'maxThreshold',
                                    type: 'error',
                                    label: this.$t('indicator.meo.maxThreshold'),
                                    text: this.$t('indicator.meo.pleaseEnterNumber')
                                }
                            } else {
                                return null
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        let payload = {
                            from: item.from,
                            to: item.to,
                            typeId: view.mainType.id,
                            timeId: item.timeId,
                            planned: item.planned,
                            bucketSize: item.bucketSize,
                            spotIds: item.spotIds
                        }
                        view.getReverseVlhEmployeeThreshold(payload)
                        .then(response => {
                                let requests = [];
                                let maxBySpotMap = {};

                                response.data.sort((a, b) => {
                                    let val = a.amountFloored - b.amountFloored;
                                    return val;
                                }).forEach(entry => {
                                    let val = Math.round(item.mode == 1 ? entry.avg : ( item.mode == 2 ? entry.min : entry.max ));
                                    if (( item.minThreshold == null || entry.amountFloored >= item.minThreshold ) && ( item.maxThreshold == null || entry.amountFloored <= item.maxThreshold )) {
                                        if (maxBySpotMap[entry.spotId] == null || maxBySpotMap[entry.spotId] < val) {
                                            maxBySpotMap[entry.spotId] = val;
                                            requests.push({
                                                typeId: item.typeId,
                                                threshold: entry.amountFloored,
                                                spotId: entry.spotId,
                                                timeId: item.timeId,
                                                employeeCount: val
                                            });
                                        }

                                    }

                                });
                                if (requests.length > 0) {
                                    view.createMultipleVlhEmployeeThreshold(requests);
                                } 
                        }).catch(function (error) {
                            view.$helpers.error(view.$t('global.notifications.error'), view.$t('indicator.meo.addValueError'));
                            console.log(error)
                        })


                    }
                },
                header: this.$t('indicator.meo.newValues') + ' ' + this.mainType.name,
                centered: true,
                expanded: true,
            });
        },
        getReverseVlhEmployeeThreshold: function (payload) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold/curve/reverse';
            let params = { storeId: this.storeId }

            return this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            })
        },
        OpenVlhEmployeeThresholdCurveModal($event) {
            let view = this;

            this.$helpers.OpenPopup({
                elRelative: $event.currentTarget,
                type: 'datafill',
                componentState: {
                    entries: [


                        {
                            label: this.$tc('global.general.day'),
                            key: 'from',
                            hidden: false,
                            type: 'date',
                            value: this.$helpers.convertDateStringTZ(this.$helpers.getMomentTZ().hours(0).minutes(0))
                        },
                        {
                            label: this.$t('roster.comp.curveType'),
                            key: 'type',
                            hidden: false,
                            type: 'dropdownsearch',
                            value: 0,
                            selectMultiple: false,
                            dropdownSearchState: {
                                toggled: false,
                                displayedItems: [],
                                input: '',
                                items: [{ label: this.$t('indicator.vlh.quarterHour'), value: 0 }, {
                                    label: "Stunde",
                                    value: 1
                                }, { label: this.$tc('global.general.day'), value: 2 }],
                                selectMultiple: false,
                                selectedItems: [],
                                selectFirst: true,
                                styleLight: true,
                            }
                        },
                    ],
                    selectCallback: function (item) {
                        let to = item.from.clone().add(1, 'days');

                        view.getEmployeeThresholdQuarterHourCurve(item.from, to, view.mainType.id, true, item.type);
                    },

                },
                header: this.$t('roster.comp.loadVlhCurve'),
                centered: true,
                expanded: true,
            });
        },
        OpenVlhEmployeeThresholdCurveView() {
            let view = this;

            view.showComponent = 'table';

            view.getEmployeeThresholdQuarterHourCurve(view.dateSelectionStart,
                view.dateSelectionStart.clone().add(1, 'days'),
                view.mainType.id, true, view.selectedTableMode, true);
        },
        closeVlhEmployeeThresholdCurveView() {
            let view = this;

            view.showComponent = 'lanes';
        },
        getEmployeeThresholdQuarterHourCurve: function (from, to, typeId, planned = true, reqType = 0, tableView) {
            let view = this;
            let url = '/api/sec/vlhemployeethreshold/curve/';
            if (reqType === 1) {
                url += 'hourly'
            } else if (reqType === 2) {
                url += 'daily'
            } else {
                url += "quarterhourly"
            }
            let params = {

                storeId: this.storeId,
            }

            let payload = {
                from: from,
                to: to,
                typeId: typeId,
                planned: planned
            };

            this.axios({
                method: 'post',
                headers: {
                    'AUTHORIZATION': "bearer " + this.$store.state.jwt
                },
                url: url,
                params: params,
                data: payload
            }).then(response => {
                if (tableView === undefined) {
                    view.exportVLHETCurveForDayPDF(response.data, from, reqType);
                } else {
                    view.thresholdCurve = response.data;
                }
            }).catch(function (error) {
                view.$helpers.error(view.$t('global.notifications.error'), view.$t('shift.template.loadVlhError'));
                console.log(error)
            })

        },
        exportVLHETCurveForDayPDF(data, from, reqType) {
            let view = this;
            var date = new Date();
            let ts = (date.getFullYear().toString() + this.$helpers.pad2(date.getMonth() + 1) + this.$helpers.pad2(date.getDate()) + this.$helpers.pad2(date.getHours()) + this.$helpers.pad2(date.getMinutes()) + this.$helpers.pad2(date.getSeconds()));


            let headers = [this.$t('store.settings.date'), this.$tc('shift.main.position'), this.$t('global.general.employeeCount')];


            let filename = 'VLH Kurve_' + this.storeSettings.name + '_' + ts;

            var body = [];

            var repDoc = this.$helpers.tableReportDoc(
                headers,
                from.format("DD.MM.YYYY"),
                'VLH Kurve ' + this.storeSettings.name,
                this.storeSettings.description,
                this.userFullname,
                9);
            var doc = repDoc.doc;
            var contentOffsetY = repDoc.contentOffsetY;
            doc.setFontSize(12);
            let divisor = reqType == 0 ? 15 : (reqType == 1 ? 60 : 24 * 60);
            data.forEach(p => {
                let line = [view.$helpers.getMomentFromStringTZ(p.date).format("DD.MM.YYYY HH:mm"), view.spotMap[p.spotId].name, p.workTime / divisor]
                body.push(line)
            })


            doc.autoTable({
                startY: contentOffsetY,
                head: [headers],
                body: body,
                headStyles: {
                    fillColor: [109, 141, 33],
                    fontSize: 7,
                },
                bodyStyles: {
                    fontSize: 7
                },
                columnStyles: {}
            })

            view.$helpers.previewPdf(doc, filename + '.pdf');
        },
    }

}
</script>

<style scoped>
div {
    font-family: DistrictPro;
}

p {
    font-family: DistrictPro;
}

.vlh-lane {
    display: flex;
    flex-wrap: wrap;
    overflow: auto;
    min-height: 250px;
}

.vlh-lane-section {
    display: flex;
    padding-right: 24px;
    flex: 1;
    border-bottom: solid 2px var(--contrast-2);
    /* gap: 10px; */
    height: 100%;
}

.vlh-section-label {
    writing-mode: vertical-rl;
    transform: rotate(-180deg);
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: white;
    padding: 15px 10px 0 10px;
}

.vlh-light-btn {
    border: 0;
    color: white;
    cursor: pointer;
    float: right;
    padding: 0 2px 15px 2px;
}

.vlh-light-btn:hover {
    background-color: white;
    color: black;
}

.vlh-light-gray {
    background: var(--contrast-0);
}


.vlh-settings {

    width: auto;
    top: 0px !important;
    left: 0;
    right: 0;
    padding: 0px 24px;
    overflow: visible;
}

.vlhe-settings .content {
    text-align: center;
    height: 750px;
}

.vlh-settings.w1200 {
    max-width: 1200px;
}


.vlh-settings .content>.half {
    float: none !important;
    display: block;
    position: relative;
    display: inline-block;
    width: 50% !important;
    margin-bottom: 20px;
}

.vlh-settings .header {
    margin-top: 16px;
    box-shadow: 0 2px 0 -1px var(--contrast-2);
}

.vlh-settings .header .fa-stack {
    float: left;
    margin: 0px -2px;
}

.vlh-settings .mainheader {
    box-shadow: 0 2px 0 -1px var(--contrast-2);
    margin: -24px 0px 8px 0px;
    width: 100%;
    height: 56px;
    color: #6d8d23;
    float: left;
    text-align: left;
    font-size: 32px;
    font-family: DistrictProBold;
}

.vlh-settings .subheader {
    /* box-shadow: 0 2px 0 -1px var(--contrast-2); */
    margin: 0px 0px 8px 0px;
    width: 100%;
    height: 44px;
    color: #6d8d23;
    float: left;
    text-align: left;
    font-size: 24px;
    font-family: DistrictProBold;
}

.has-header>.has-header>.scrollbar-container {
    height: calc(100% - var(--header-height) - var(--tab-menu-height)) !important;
    overflow-x: hidden;
    top: var(--header-height);
    padding: 0px 14px;
}

.label-bold {
    font-family: DistrictProBold;
    font-weight: 800;
    font-size: 24px;
    color: var(--contrast-4);
    white-space: nowrap;
    border: 0;
}

.section {
    display: flex;
    flex-direction: column;
    padding: 10px;
}

.header {
    position: absolute;
    top: 245px;
    left: -28px;
    width: 30px;
    margin: auto;
    align-items: center;
    height: fit-content;
}

.time-table-header {
    background: var(--contrast-4);
    color: var(--bg);
    font-weight: bold;
    width: 100%;
    text-align: left;
    padding: 5px;
}

.vlh-pl-5 {
    padding-left: 5px;
}

.add-btn:hover {
    color: #6d8d23;
}

.vlh-curve {
    margin: 10px;
}

</style>
